<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h1 style="text-align: center">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="max-width: 100px;"
              src="@/assets/images/headwear.jpg"
              alt="" />
          </h1>
          <d-alert
            v-if="invalidError"
            theme="danger"
            show>
            {{ $t('login.customerPanelInfo') }}
          </d-alert>
          <d-alert
            v-if="authError"
            theme="danger"
            show>
            {{ $t('login.authError') }}
          </d-alert>
          <form @submit="login">
            <div class="form-group">
              <label>{{ $t('ui.emailAddress') }}</label>
              <d-input
                v-model="email"
                name="email"
                type="email"
                @input="clearError('email')"
                :class="{'is-invalid' : larErrors.has('email')}"
                :placeholder="$t('login.emailPlaceholder')" />
              <div class="invalid-feedback" v-text="larErrors.get('email')"></div>
            </div>
            <div class="form-group">
              <label>{{ $t('login.password') }}</label>
              <d-input
                v-model="password"
                name="password"
                type="password"
                autocomplete="off"
                @input="clearError('password')"
                :class="{'is-invalid' : larErrors.has('password')}"
                :placeholder="$t('login.passwordPlaceholder')" />
              <div class="invalid-feedback" v-text="larErrors.get('password')"></div>
            </div>
            <button
              type="submit"
              class="btn btn-pill btn-accent d-table mx-auto"
              @click.prevent="login"
              :disabled="submitting">
              <template v-if="!submitting">{{ $t('login.loginLabel') }}</template>
              <template v-else>{{ $t('login.loginInProgress') }}</template>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LarErrors from '../utils/Errors';

export default {
  name: 'Login',
  components: {
    LarErrors
  },
  computed: {
    invalidError () {
      return this.$route.path === '/logowanie/invalid';
    }
  },
  data () {
    return {
      authError: false,
      submitting: false,
      larErrors: LarErrors,
      email: '',
      password: '',
    }
  },
  methods: {
    clearError () {
      this.authError = false;
    },
    login () {
      this.clearError();
      this.submitting = true;
      this.$http.post('/auth/login', {
        email: this.email,
        password: this.password
      }).then((response) => {
        if (response.data && response.data.user && response.data.user.type === 'customer') {
          this.submitting = false;
          this.$router.push('/logowanie/invalid');
          return;
        }

        this.submitting = false;
        window.localStorage.setItem('token', response.data.token);
        this.$http.defaults.headers.Authorization = `Bearer ${response.data.token}`;
        this.$store.commit('setCustomerID', response.data.user.customer_id);
        this.$store.commit('setUserID', response.data.user.id);
        this.$store.commit('setUserName', response.data.user.name);
        this.$store.commit('setUserEmail', response.data.user.email);
        this.$store.commit('setUserPermissions', response.data.user.permissions);
        this.$store.commit('setUserType', response.data.user.type);
        this.$store.commit('setUserLang', response.data.user.language_id);

        this.$nextTick(() => {
          if (response.data.user.permissions.home) {
            this.$router.push('/kokpit');
          } else {
            this.$router.push('/zamowienia');
          }

          let currentLanguageID = this.$i18n.locale === 'pl' ? 1 : 2;

          if (response.data.user.language_id > 0 && currentLanguageID !== response.data.user.language_id) {
            window.localStorage.setItem('headwear-crm-ui-language', response.data.user.language_id);
            window.location.reload();
          }
        });
      }).catch((error) => {
        console.log(error);
        this.submitting = false;
        this.authError = true;
      });
    }
  }
}
</script>

<style scoped>

</style>
